import * as Yup from "yup";

const digitsOnly = (value) => /^\d+$/.test(value);
const nepaliCharacterRegex = /^[\u0900-\u097F\s]+$/;

const COOPValidation = Yup.object({
  nameEng: Yup.string().required("Cooperative Name is required!"),
  nameNep: Yup.string().required("Cooperative Name is required!"),

  // accountType: Yup.string(),
  phoneNumberNep: Yup.string()
    // .test("Digits  only", "Please enter only digits!", digitsOnly)
    .matches(nepaliCharacterRegex, "Only Nepali characters are allowed")
    .required("Phone number is required!"),
  phoneNumberEng: Yup.string()
    .test("Digits  only", "Please enter only digits!", digitsOnly)
    .required("Phone number is required!"),
  email: Yup.string()
    .required("Email Address is required!")
    .matches(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Email is invalid!"
    ),
  addressEng: Yup.string().required("Address is required!"),
  addressNep: Yup.string().required("Address is required!"),

  facebook: Yup.string(),
  twitter: Yup.string(),
  username: Yup.string().required("Username is required!"),
  fullName: Yup.string().required("Full Name is required!"),
  messageEng: Yup.string().required("Message is required!"),
  messageNep: Yup.string()
    .required("Message is required!")
    .matches(nepaliCharacterRegex, "Only Nepali characters are allowed"),
  password: Yup.string()
    .required("Password is required!")
    .min(8, "Password is too short - should be 8 chars minimum.")
    .matches(
      /^(?=.[a-z])(?=.[A-Z])(?=.[0-9])(?=.[!@#\$%\^&\*])(?=.{8,})/,
      "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
    ),
  loginEmail: Yup.string()
    .required("Email Address is required!")
    .matches(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Email is invalid!"
    ),
});

export default COOPValidation;